import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { api, errMsg } from "../../lib/api";
import { useLang } from "../../lib/i18n";

const SEV = { high: "border-red-200 bg-red-50 text-red-800", medium: "border-amber-200 bg-amber-50 text-amber-900", low: "border-slate-200 bg-slate-50 text-slate-700" };

export function ContractReviewDialog({ id, onClose }) {
  const { t } = useLang();
  const [res, setRes] = useState(null);
  useEffect(() => {
    api.post(`/ai/contracts/${id}/review`).then((r) => setRes(r.data)).catch((e) => { toast.error(errMsg(e)); onClose(); });
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto" data-testid="contract-review-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><ShieldCheck className="w-5 h-5 text-[#D9531E]" />{t("AI contract review", "Revisión del contrato con IA")}</DialogTitle></DialogHeader>
        {!res ? <div className="flex items-center gap-2 text-slate-500" data-testid="contract-review-loading"><Loader2 className="w-4 h-4 animate-spin" />{t("Reviewing…", "Revisando…")}</div> : (
          <div className="grid gap-2" data-testid="contract-review-result">
            {res.summary && <p className="text-sm">{res.summary}</p>}
            {!res.issues.length && <p className="text-sm text-emerald-700 font-semibold" data-testid="contract-review-ok">{t("No issues found.", "No se encontraron problemas.")}</p>}
            {res.issues.map((i, n) => (
              <div key={n} className={`rounded-xl border p-3 text-sm ${SEV[i.severity] || SEV.low}`} data-testid={`contract-review-issue-${n}`}>
                <div className="font-semibold">{i.message}</div>
                {i.suggestion && <div className="text-xs mt-1">{i.suggestion}</div>}
              </div>
            ))}
            <p className="text-xs text-slate-500">{t("Edit the contract, save, and review again if needed. Nothing was changed or sent.", "Edite el contrato, guarde y revise de nuevo si hace falta. No se cambió ni se envió nada.")}</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
